import { canUseDOM } from './can-use-dom';

/**
 * Get the client side URL.
 *
 * @returns The fully qualified client side URL.
 */
export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;

    return `${protocol}//${domain}${port ? `:${port}` : ''}`;
  }

  // In case of...

  if (process.env['VERCEL_PROJECT_PRODUCTION_URL']) {
    return `https://${process.env['VERCEL_PROJECT_PRODUCTION_URL']}`;
  }

  return process.env['NEXT_PUBLIC_SERVER_URL'] || '';
};
